<mat-form-field>
  <mat-label>Text Control Input</mat-label>
  <input matInput [ngModel]="controlValue|async" (ngModelChange)="controlValue.next($event)" name="controlValue">
</mat-form-field>

